<template>
  <div>
    <b-button-group :vertical="vertical" class="col-12 p-0">
      <b-button :size="size" v-for="(value, index) in options" :key="index"
      :variant="variant"
      :pressed="isPressed(value, index)"
      @click="valueOptions(value, index, $event)"
      >{{ value.text }}
      </b-button>
    </b-button-group>
 </div>
</template>
    
<script>
import { BButton, BButtonGroup } from "bootstrap-vue";

export default {
  name: "OptionsFilters",
  components: {
    BButton,
    BButtonGroup,
  },
  data() {
    return {
      optionButtons: []
    };
  },
  created() {
    this.buttonsLength()
  },
  methods: {
    isPressed(value, index) {
      // Si el padre controla la selección via selected_value, lo usamos; si no, estado interno
      if (this.selected_value !== undefined) {
        return value.value === this.selected_value
      }
      return this.optionButtons[index]
    },
    valueOptions(value, index, event) {
      this.$emit('optionsFilter', value, this.name_prop);
      this.optionButtons = this.optionButtons.map((item) => {
        item = false
        return item
      })
      this.optionButtons[index] = true
      // Evita que el boton clickeado quede con foco/estilo activo cuando el padre
      // controla la seleccion via selected_value (ej. toggle bloqueado).
      if (event && event.currentTarget && event.currentTarget.blur) event.currentTarget.blur()
    },
    buttonsLength() {
      for (let i = 0; i < this.options.length; i++) {
        this.optionButtons.push(false)
      }
    }
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    variant: {
      type: String,
      default: "outline-secondary",
    },
    size: {
      type: String,
      default: "sm",
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    name_prop: {
      type: String,
    },
    selected_value: {
      default: undefined
    }
  },
};
</script>
<style>
</style>